<template>
  <div>
    <van-form label-width="100" @submit="submit">
      <van-field
        v-model="identity.value"
        name="identity"
        label="客户身份"
        placeholder="请选择客户身份"
        readonly
        :right-icon="'arrow'"
        @click="selectIdentity"
      />
      <van-field
        v-model="cityInfo.text"
        name="cityInfo"
        label="用车省份/城市"
        placeholder="请选择用车省份/城市"
        readonly
        :right-icon="'arrow'"
        @click="selectCity"
      />
      <ShippingAddress :datas="shippingAddress" />
      <van-field v-model="dealer.name" name="dealer" label="经销商" placeholder="请选择经销商" readonly :right-icon="'arrow'" @click="selectDealer">
        <template #input>
          <div>
            <p>{{ dealer.name || '请选择经销商' }}</p>
          </div>
        </template>
      </van-field>
      <van-button class="button" type="primary" size="large" native-type="submit">提交</van-button>
    </van-form>
    <SelectIdentity :identity="identity" :showNum="showIdentity" @getIdentity="getIdentity" />
    <SelectCity :fromCompleteInfo="true" :showNum="showCity" :provinceCity="cityInfo.provinceCity" @getCity="getCity" />
    <SwitchDealer :showNum="showDealer" @dealerFn="dealerFn" from="completeInfo" />
  </div>
</template>

<script>
import { onMounted, reactive, toRefs } from 'vue'
import { useStore } from 'vuex'
import { onBeforeRouteLeave } from 'vue-router'
import { Toast } from 'vant'
import { getProvinceIdAndCityId } from '@/util/city'
import { getAddressList, getProfile, addProfile, updateProfile } from '@/api/profile'
import { getDealers } from '@/api/plan'
import SelectIdentity from '@/components/common/SelectIdentity.vue'
import SelectCity from '@/components/common/SelectCity.vue'
import SwitchDealer from '@/components/dealer/SwitchDealer'
import ShippingAddress from '@/components/shippingAddress/ShippingAddress.vue'

const identityList = [
  {
    key: 1,
    value: '车主'
  },
  {
    key: 2,
    value: '用车人'
  },
  {
    key: 3,
    value: '其他'
  }
]

export default {
  components: {
    SelectIdentity,
    SelectCity,
    SwitchDealer,
    ShippingAddress
  },

  setup() {
    const store = useStore()
    const { currentCompletedInfo } = store.state
    const state = reactive({
      showIdentity: 0,
      showCity: 0,
      showShippingCity: 0,
      showDealer: 0,

      isNew: true,
      identity: {
        key: 0,
        value: ''
      },
      cityInfo: {
        text: ''
      },
      shippingAddress: {},
      dealer: { name: '', gs_code: '' }
    })

    onBeforeRouteLeave(to => {
      if (to.path === '/addressList') {
        // 保留用户当前选择，当用户进入地址列表页面
        store.commit('SETCURRENTCOMPLETEDINFO', {
          isNew: state.isNew,
          identity: state.identity,
          cityInfo: state.cityInfo,
          dealer: state.dealer
        })
      } else {
        store.commit('SETCURRENTCOMPLETEDINFO', {})
      }
    })

    const profile = async () => {
      // 获取默认地址
      const { addresses } = await getAddressList()
      const defaultShippingAddresses = addresses.find(a => a.isDefault) || {}
      state.shippingAddress = defaultShippingAddresses

      let data
      try {
        data = await getProfile()

        if (data && data.profile && data.profile.customerId) {
          state.isNew = false
        } else {
          throw new Error()
        }
      } catch {
        data = {
          profile: {}
        }
      }
      const { profile } = data

      // 获取用户当前选择
      if (currentCompletedInfo.cityInfo) {
        state.isNew = currentCompletedInfo.isNew
        state.identity = currentCompletedInfo.identity
        state.cityInfo = currentCompletedInfo.cityInfo
        state.dealer = currentCompletedInfo.dealer

        return
      }

      if (profile.customerIdentity) state.identity = identityList.find(i => i.key === profile.customerIdentity)

      if (profile.gsCode) {
        const { list } = await getDealers({ gsCode: profile.gsCode })
        state.dealer = { ...list[0], gsCode: list[0].gs_code }
      }

      if (profile.cityName) {
        state.cityInfo = {
          text: `${profile.provinceName}/${profile.cityName}`,
          provinceCity: [profile.provinceName, profile.cityName],
          indexArr: [profile.provinceId, profile.cityId],
          cityId: profile.cityId,
          cityName: profile.cityName,
          provinceId: profile.provinceId,
          provinceName: profile.provinceName
        }
      } else {
        const { locationInfo } = store.state
        // 获取当前定位省份和城市Id
        const indexArr = await getProvinceIdAndCityId(locationInfo.province, locationInfo.city)

        state.cityInfo = indexArr.length
          ? {
              text: `${locationInfo.province}/${locationInfo.city}`,
              provinceCity: [locationInfo.province, locationInfo.city],
              indexArr: indexArr,
              cityName: locationInfo.city,
              provinceName: locationInfo.province
            }
          : { text: '' }
      }
    }

    onMounted(() => {
      profile()
    })

    const selectIdentity = () => (state.showIdentity += 1)

    const getIdentity = val => (state.identity = val)

    const selectCity = () => (state.showCity += 1)

    const getCity = val => (state.cityInfo = val)

    const selectDealer = () => (state.showDealer += 1)

    const dealerFn = data => (state.dealer = data)

    const submit = async () => {
      let params = {
        customerIdentity: state.identity.key,
        gsCode: state.dealer.gs_code
      }

      if (state.cityInfo.cityName) {
        params = {
          cityId: state.cityInfo.indexArr[1],
          cityName: state.cityInfo.cityName,
          provinceId: state.cityInfo.indexArr[0],
          provinceName: state.cityInfo.provinceName,
          ...params
        }
      }

      try {
        if (state.isNew) {
          // 创建个人信息
          await addProfile(params)
        } else {
          // 修改个人信息
          await updateProfile(params)
        }
        store.commit('SETPROFILE', params)
        // 提交信息成功，返回上一层页面
        Toast({ message: state.isNew ? '完善信息成功' : '修改信息成功' })
        history.back()
      } catch {
        Toast({ message: '提交信息失败' })
      }
    }

    return {
      ...toRefs(state),
      selectIdentity,
      getIdentity,
      selectCity,
      getCity,
      selectDealer,
      dealerFn,
      submit
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  margin-top: 10px;
}
.dealer {
  :deep(.van-field__control) {
    overflow: auto;
  }
}
</style>
